var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTierBg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 173 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.9105 1.47152C85.4877 0.560939 87.4309 0.56094 89.008 1.47152L169.843 48.1416C171.42 49.0522 172.392 50.735 172.392 52.5561V145.896C172.392 147.717 171.42 149.4 169.843 150.311L89.008 196.981C87.4309 197.891 85.4877 197.891 83.9105 196.981L3.0756 150.311C1.49843 149.4 0.526855 147.717 0.526855 145.896V52.5561C0.526855 50.735 1.49843 49.0522 3.0756 48.1416L83.9105 1.47152Z",
    fill: "#EDEDED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2496 36.3359C85.6154 35.5473 87.2983 35.5473 88.6641 36.3359L139.818 65.8698C141.184 66.6584 142.026 68.1158 142.026 69.693V128.761C142.026 130.338 141.184 131.795 139.818 132.584L88.6641 162.118C87.2983 162.906 85.6154 162.906 84.2496 162.118L33.0953 132.584C31.7294 131.795 30.888 130.338 30.888 128.761V69.693C30.888 68.1158 31.7294 66.6584 33.0953 65.8698L84.2496 36.3359Z",
    stroke: "#E4E4E4",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M154.379 93.9316L154.379 128.987",
    stroke: "#E4E4E4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4688 69.5317V86.9703",
    stroke: "#E4E4E4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8164 64.5979C87.4767 63.1668 85.4403 63.1668 85.1005 64.5979L76.7683 99.6991C76.7329 99.8481 76.6733 99.9903 76.5917 100.12L61.3251 124.388C60.5565 125.61 61.9212 127.052 63.1834 126.351L85.7815 113.816C86.2026 113.582 86.7144 113.582 87.1355 113.816L109.734 126.351C110.996 127.052 112.36 125.61 111.592 124.388L96.3252 100.12C96.2436 99.9903 96.184 99.8481 96.1486 99.6991L87.8164 64.5979Z",
    fill: "#E4E4E4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTierBg2);
export default __webpack_public_path__ + "static/media/tier-bg-2.e056ee8b0f795f82d78d4de8b0d5b8b2.svg";
export { ForwardRef as ReactComponent };